import React, { FC } from "react";
import { Button } from "@skyportal/ui-kit";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Bucket } from "containers/BucketsPageContent/mappers/bucketsMapper";

import BucketModalShell from "../BucketModalShell";
import shellStyles from "../BucketModalShell/BucketModalShell.module.css";
import { BaseBucketModalProps } from "../types";

import styles from "./DeleteBucketModal.module.css";

interface Props extends BaseBucketModalProps {
  bucket: Bucket | null;
  onConfirm: () => void;
}

const DeleteBucketModal: FC<Props> = ({ open, bucket, onClose, onConfirm }) => {
  const { t } = useTranslation("storageOverview");

  return (
    <BucketModalShell
      open={open}
      onClose={onClose}
      title={t("modals.delete.title")}
      controls={
        <div className={cn(shellStyles.controls, styles.controls)}>
          <Button type="secondary" onClick={onClose}>
            {t("common:Cancel")}
          </Button>
          <Button type="primary" onClick={onConfirm}>
            {t("common:Delete")}
          </Button>
        </div>
      }
    >
      <div className={cn(shellStyles.body, styles.body)}>
        <div className={styles.text}>
          {t("modals.delete.message", { bucketName: bucket?.name })}
        </div>
      </div>
    </BucketModalShell>
  );
};

export default DeleteBucketModal;
